/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkflowsRouteImport } from './routes/workflows'
import { Route as VaultRouteImport } from './routes/vault'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RoutinesRouteImport } from './routes/routines'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PairRouteImport } from './routes/pair'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as MemoryRouteImport } from './routes/memory'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as AllowanceRouteImport } from './routes/allowance'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as ActivitiesRouteImport } from './routes/activities'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as WorkflowsIndexRouteImport } from './routes/workflows.index'
import { Route as AgentsIndexRouteImport } from './routes/agents.index'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as WorkflowsIdRouteImport } from './routes/workflows.$id'
import { Route as SettingsWhatsappConnectRouteImport } from './routes/settings.whatsapp-connect'
import { Route as SettingsTriggersRouteImport } from './routes/settings.triggers'
import { Route as SettingsSupportRouteImport } from './routes/settings.support'
import { Route as SettingsSourceControlRouteImport } from './routes/settings.source-control'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsPackagesRouteImport } from './routes/settings.packages'
import { Route as SettingsOrganizationRouteImport } from './routes/settings.organization'
import { Route as SettingsMcpConnectRouteImport } from './routes/settings.mcp-connect'
import { Route as SettingsLegalRouteImport } from './routes/settings.legal'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsEmailConnectRouteImport } from './routes/settings.email-connect'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsCommsRouteImport } from './routes/settings.comms'
import { Route as SettingsBrowserConnectRouteImport } from './routes/settings.browser-connect'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as ProjectsProjectKeyRouteImport } from './routes/projects.$projectKey'
import { Route as DevContextPanelRouteImport } from './routes/dev.context-panel'
import { Route as ConnectCallbackRouteImport } from './routes/connect_.callback'
import { Route as AgentsAgentIdRouteImport } from './routes/agents.$agentId'
import { Route as ChatPullRequestsRouteImport } from './routes/_chat.pull-requests'
import { Route as SettingsAppConnectAppIdRouteImport } from './routes/settings.app-connect.$appId'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'

const WorkflowsRoute = WorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => rootRouteImport,
} as any)
const VaultRoute = VaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutinesRoute = RoutinesRouteImport.update({
  id: '/routines',
  path: '/routines',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryRoute = MemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const AllowanceRoute = AllowanceRouteImport.update({
  id: '/allowance',
  path: '/allowance',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivitiesRoute = ActivitiesRouteImport.update({
  id: '/activities',
  path: '/activities',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsIndexRoute = WorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkflowsRoute,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsRoute,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const WorkflowsIdRoute = WorkflowsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => WorkflowsRoute,
} as any)
const SettingsWhatsappConnectRoute = SettingsWhatsappConnectRouteImport.update({
  id: '/whatsapp-connect',
  path: '/whatsapp-connect',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTriggersRoute = SettingsTriggersRouteImport.update({
  id: '/triggers',
  path: '/triggers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSupportRoute = SettingsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSourceControlRoute = SettingsSourceControlRouteImport.update({
  id: '/source-control',
  path: '/source-control',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPackagesRoute = SettingsPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMcpConnectRoute = SettingsMcpConnectRouteImport.update({
  id: '/mcp-connect',
  path: '/mcp-connect',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLegalRoute = SettingsLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEmailConnectRoute = SettingsEmailConnectRouteImport.update({
  id: '/email-connect',
  path: '/email-connect',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCommsRoute = SettingsCommsRouteImport.update({
  id: '/comms',
  path: '/comms',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBrowserConnectRoute = SettingsBrowserConnectRouteImport.update({
  id: '/browser-connect',
  path: '/browser-connect',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectsProjectKeyRoute = ProjectsProjectKeyRouteImport.update({
  id: '/projects/$projectKey',
  path: '/projects/$projectKey',
  getParentRoute: () => rootRouteImport,
} as any)
const DevContextPanelRoute = DevContextPanelRouteImport.update({
  id: '/dev/context-panel',
  path: '/dev/context-panel',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect_/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AgentsRoute,
} as any)
const ChatPullRequestsRoute = ChatPullRequestsRouteImport.update({
  id: '/pull-requests',
  path: '/pull-requests',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsAppConnectAppIdRoute = SettingsAppConnectAppIdRouteImport.update({
  id: '/app-connect/$appId',
  path: '/app-connect/$appId',
  getParentRoute: () => SettingsRoute,
} as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/activities': typeof ActivitiesRoute
  '/agents': typeof AgentsRouteWithChildren
  '/allowance': typeof AllowanceRoute
  '/connect': typeof ConnectRoute
  '/knowledge': typeof KnowledgeRoute
  '/memory': typeof MemoryRoute
  '/messages': typeof MessagesRoute
  '/organization': typeof OrganizationRoute
  '/pair': typeof PairRoute
  '/pricing': typeof PricingRoute
  '/routines': typeof RoutinesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/team': typeof TeamRoute
  '/usage': typeof UsageRoute
  '/vault': typeof VaultRoute
  '/workflows': typeof WorkflowsRouteWithChildren
  '/pull-requests': typeof ChatPullRequestsRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/dev/context-panel': typeof DevContextPanelRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/browser-connect': typeof SettingsBrowserConnectRoute
  '/settings/comms': typeof SettingsCommsRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/email-connect': typeof SettingsEmailConnectRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/legal': typeof SettingsLegalRoute
  '/settings/mcp-connect': typeof SettingsMcpConnectRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/packages': typeof SettingsPackagesRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/support': typeof SettingsSupportRoute
  '/settings/triggers': typeof SettingsTriggersRoute
  '/settings/whatsapp-connect': typeof SettingsWhatsappConnectRoute
  '/workflows/$id': typeof WorkflowsIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/settings/app-connect/$appId': typeof SettingsAppConnectAppIdRoute
}
export interface FileRoutesByTo {
  '/activities': typeof ActivitiesRoute
  '/allowance': typeof AllowanceRoute
  '/connect': typeof ConnectRoute
  '/knowledge': typeof KnowledgeRoute
  '/memory': typeof MemoryRoute
  '/messages': typeof MessagesRoute
  '/organization': typeof OrganizationRoute
  '/pair': typeof PairRoute
  '/pricing': typeof PricingRoute
  '/routines': typeof RoutinesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/team': typeof TeamRoute
  '/usage': typeof UsageRoute
  '/vault': typeof VaultRoute
  '/pull-requests': typeof ChatPullRequestsRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/connect/callback': typeof ConnectCallbackRoute
  '/dev/context-panel': typeof DevContextPanelRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/browser-connect': typeof SettingsBrowserConnectRoute
  '/settings/comms': typeof SettingsCommsRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/email-connect': typeof SettingsEmailConnectRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/legal': typeof SettingsLegalRoute
  '/settings/mcp-connect': typeof SettingsMcpConnectRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/packages': typeof SettingsPackagesRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/support': typeof SettingsSupportRoute
  '/settings/triggers': typeof SettingsTriggersRoute
  '/settings/whatsapp-connect': typeof SettingsWhatsappConnectRoute
  '/workflows/$id': typeof WorkflowsIdRoute
  '/': typeof ChatIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/workflows': typeof WorkflowsIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/settings/app-connect/$appId': typeof SettingsAppConnectAppIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/activities': typeof ActivitiesRoute
  '/agents': typeof AgentsRouteWithChildren
  '/allowance': typeof AllowanceRoute
  '/connect': typeof ConnectRoute
  '/knowledge': typeof KnowledgeRoute
  '/memory': typeof MemoryRoute
  '/messages': typeof MessagesRoute
  '/organization': typeof OrganizationRoute
  '/pair': typeof PairRoute
  '/pricing': typeof PricingRoute
  '/routines': typeof RoutinesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/team': typeof TeamRoute
  '/usage': typeof UsageRoute
  '/vault': typeof VaultRoute
  '/workflows': typeof WorkflowsRouteWithChildren
  '/_chat/pull-requests': typeof ChatPullRequestsRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/connect_/callback': typeof ConnectCallbackRoute
  '/dev/context-panel': typeof DevContextPanelRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/browser-connect': typeof SettingsBrowserConnectRoute
  '/settings/comms': typeof SettingsCommsRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/email-connect': typeof SettingsEmailConnectRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/legal': typeof SettingsLegalRoute
  '/settings/mcp-connect': typeof SettingsMcpConnectRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/packages': typeof SettingsPackagesRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/support': typeof SettingsSupportRoute
  '/settings/triggers': typeof SettingsTriggersRoute
  '/settings/whatsapp-connect': typeof SettingsWhatsappConnectRoute
  '/workflows/$id': typeof WorkflowsIdRoute
  '/_chat/': typeof ChatIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/settings/app-connect/$appId': typeof SettingsAppConnectAppIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activities'
    | '/agents'
    | '/allowance'
    | '/connect'
    | '/knowledge'
    | '/memory'
    | '/messages'
    | '/organization'
    | '/pair'
    | '/pricing'
    | '/routines'
    | '/settings'
    | '/team'
    | '/usage'
    | '/vault'
    | '/workflows'
    | '/pull-requests'
    | '/agents/$agentId'
    | '/connect/callback'
    | '/dev/context-panel'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/billing'
    | '/settings/browser-connect'
    | '/settings/comms'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/email-connect'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/legal'
    | '/settings/mcp-connect'
    | '/settings/organization'
    | '/settings/packages'
    | '/settings/providers'
    | '/settings/source-control'
    | '/settings/support'
    | '/settings/triggers'
    | '/settings/whatsapp-connect'
    | '/workflows/$id'
    | '/agents/'
    | '/workflows/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/settings/app-connect/$appId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/activities'
    | '/allowance'
    | '/connect'
    | '/knowledge'
    | '/memory'
    | '/messages'
    | '/organization'
    | '/pair'
    | '/pricing'
    | '/routines'
    | '/settings'
    | '/team'
    | '/usage'
    | '/vault'
    | '/pull-requests'
    | '/agents/$agentId'
    | '/connect/callback'
    | '/dev/context-panel'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/billing'
    | '/settings/browser-connect'
    | '/settings/comms'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/email-connect'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/legal'
    | '/settings/mcp-connect'
    | '/settings/organization'
    | '/settings/packages'
    | '/settings/providers'
    | '/settings/source-control'
    | '/settings/support'
    | '/settings/triggers'
    | '/settings/whatsapp-connect'
    | '/workflows/$id'
    | '/'
    | '/agents'
    | '/workflows'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/settings/app-connect/$appId'
  id:
    | '__root__'
    | '/_chat'
    | '/activities'
    | '/agents'
    | '/allowance'
    | '/connect'
    | '/knowledge'
    | '/memory'
    | '/messages'
    | '/organization'
    | '/pair'
    | '/pricing'
    | '/routines'
    | '/settings'
    | '/team'
    | '/usage'
    | '/vault'
    | '/workflows'
    | '/_chat/pull-requests'
    | '/agents/$agentId'
    | '/connect_/callback'
    | '/dev/context-panel'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/billing'
    | '/settings/browser-connect'
    | '/settings/comms'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/email-connect'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/legal'
    | '/settings/mcp-connect'
    | '/settings/organization'
    | '/settings/packages'
    | '/settings/providers'
    | '/settings/source-control'
    | '/settings/support'
    | '/settings/triggers'
    | '/settings/whatsapp-connect'
    | '/workflows/$id'
    | '/_chat/'
    | '/agents/'
    | '/workflows/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
    | '/settings/app-connect/$appId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  ActivitiesRoute: typeof ActivitiesRoute
  AgentsRoute: typeof AgentsRouteWithChildren
  AllowanceRoute: typeof AllowanceRoute
  ConnectRoute: typeof ConnectRoute
  KnowledgeRoute: typeof KnowledgeRoute
  MemoryRoute: typeof MemoryRoute
  MessagesRoute: typeof MessagesRoute
  OrganizationRoute: typeof OrganizationRoute
  PairRoute: typeof PairRoute
  PricingRoute: typeof PricingRoute
  RoutinesRoute: typeof RoutinesRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  TeamRoute: typeof TeamRoute
  UsageRoute: typeof UsageRoute
  VaultRoute: typeof VaultRoute
  WorkflowsRoute: typeof WorkflowsRouteWithChildren
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  DevContextPanelRoute: typeof DevContextPanelRoute
  ProjectsProjectKeyRoute: typeof ProjectsProjectKeyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workflows': {
      id: '/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof WorkflowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vault': {
      id: '/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof VaultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routines': {
      id: '/routines'
      path: '/routines'
      fullPath: '/routines'
      preLoaderRoute: typeof RoutinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory': {
      id: '/memory'
      path: '/memory'
      fullPath: '/memory'
      preLoaderRoute: typeof MemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/allowance': {
      id: '/allowance'
      path: '/allowance'
      fullPath: '/allowance'
      preLoaderRoute: typeof AllowanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activities': {
      id: '/activities'
      path: '/activities'
      fullPath: '/activities'
      preLoaderRoute: typeof ActivitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/': {
      id: '/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof WorkflowsIndexRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/agents/': {
      id: '/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/workflows/$id': {
      id: '/workflows/$id'
      path: '/$id'
      fullPath: '/workflows/$id'
      preLoaderRoute: typeof WorkflowsIdRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/settings/whatsapp-connect': {
      id: '/settings/whatsapp-connect'
      path: '/whatsapp-connect'
      fullPath: '/settings/whatsapp-connect'
      preLoaderRoute: typeof SettingsWhatsappConnectRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/triggers': {
      id: '/settings/triggers'
      path: '/triggers'
      fullPath: '/settings/triggers'
      preLoaderRoute: typeof SettingsTriggersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/support': {
      id: '/settings/support'
      path: '/support'
      fullPath: '/settings/support'
      preLoaderRoute: typeof SettingsSupportRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/source-control': {
      id: '/settings/source-control'
      path: '/source-control'
      fullPath: '/settings/source-control'
      preLoaderRoute: typeof SettingsSourceControlRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/packages': {
      id: '/settings/packages'
      path: '/packages'
      fullPath: '/settings/packages'
      preLoaderRoute: typeof SettingsPackagesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/mcp-connect': {
      id: '/settings/mcp-connect'
      path: '/mcp-connect'
      fullPath: '/settings/mcp-connect'
      preLoaderRoute: typeof SettingsMcpConnectRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/legal': {
      id: '/settings/legal'
      path: '/legal'
      fullPath: '/settings/legal'
      preLoaderRoute: typeof SettingsLegalRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/email-connect': {
      id: '/settings/email-connect'
      path: '/email-connect'
      fullPath: '/settings/email-connect'
      preLoaderRoute: typeof SettingsEmailConnectRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/comms': {
      id: '/settings/comms'
      path: '/comms'
      fullPath: '/settings/comms'
      preLoaderRoute: typeof SettingsCommsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/browser-connect': {
      id: '/settings/browser-connect'
      path: '/browser-connect'
      fullPath: '/settings/browser-connect'
      preLoaderRoute: typeof SettingsBrowserConnectRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/projects/$projectKey': {
      id: '/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/projects/$projectKey'
      preLoaderRoute: typeof ProjectsProjectKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/context-panel': {
      id: '/dev/context-panel'
      path: '/dev/context-panel'
      fullPath: '/dev/context-panel'
      preLoaderRoute: typeof DevContextPanelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect_/callback': {
      id: '/connect_/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/_chat/pull-requests': {
      id: '/_chat/pull-requests'
      path: '/pull-requests'
      fullPath: '/pull-requests'
      preLoaderRoute: typeof ChatPullRequestsRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/app-connect/$appId': {
      id: '/settings/app-connect/$appId'
      path: '/app-connect/$appId'
      fullPath: '/settings/app-connect/$appId'
      preLoaderRoute: typeof SettingsAppConnectAppIdRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatPullRequestsRoute: typeof ChatPullRequestsRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatPullRequestsRoute: ChatPullRequestsRoute,
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface AgentsRouteChildren {
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
}

const AgentsRouteChildren: AgentsRouteChildren = {
  AgentsAgentIdRoute: AgentsAgentIdRoute,
  AgentsIndexRoute: AgentsIndexRoute,
}

const AgentsRouteWithChildren =
  AgentsRoute._addFileChildren(AgentsRouteChildren)

interface SettingsRouteChildren {
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsBrowserConnectRoute: typeof SettingsBrowserConnectRoute
  SettingsCommsRoute: typeof SettingsCommsRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsEmailConnectRoute: typeof SettingsEmailConnectRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsLegalRoute: typeof SettingsLegalRoute
  SettingsMcpConnectRoute: typeof SettingsMcpConnectRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsPackagesRoute: typeof SettingsPackagesRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSourceControlRoute: typeof SettingsSourceControlRoute
  SettingsSupportRoute: typeof SettingsSupportRoute
  SettingsTriggersRoute: typeof SettingsTriggersRoute
  SettingsWhatsappConnectRoute: typeof SettingsWhatsappConnectRoute
  SettingsAppConnectAppIdRoute: typeof SettingsAppConnectAppIdRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsBrowserConnectRoute: SettingsBrowserConnectRoute,
  SettingsCommsRoute: SettingsCommsRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsEmailConnectRoute: SettingsEmailConnectRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsLegalRoute: SettingsLegalRoute,
  SettingsMcpConnectRoute: SettingsMcpConnectRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsPackagesRoute: SettingsPackagesRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSourceControlRoute: SettingsSourceControlRoute,
  SettingsSupportRoute: SettingsSupportRoute,
  SettingsTriggersRoute: SettingsTriggersRoute,
  SettingsWhatsappConnectRoute: SettingsWhatsappConnectRoute,
  SettingsAppConnectAppIdRoute: SettingsAppConnectAppIdRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface WorkflowsRouteChildren {
  WorkflowsIdRoute: typeof WorkflowsIdRoute
  WorkflowsIndexRoute: typeof WorkflowsIndexRoute
}

const WorkflowsRouteChildren: WorkflowsRouteChildren = {
  WorkflowsIdRoute: WorkflowsIdRoute,
  WorkflowsIndexRoute: WorkflowsIndexRoute,
}

const WorkflowsRouteWithChildren = WorkflowsRoute._addFileChildren(
  WorkflowsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  ActivitiesRoute: ActivitiesRoute,
  AgentsRoute: AgentsRouteWithChildren,
  AllowanceRoute: AllowanceRoute,
  ConnectRoute: ConnectRoute,
  KnowledgeRoute: KnowledgeRoute,
  MemoryRoute: MemoryRoute,
  MessagesRoute: MessagesRoute,
  OrganizationRoute: OrganizationRoute,
  PairRoute: PairRoute,
  PricingRoute: PricingRoute,
  RoutinesRoute: RoutinesRoute,
  SettingsRoute: SettingsRouteWithChildren,
  TeamRoute: TeamRoute,
  UsageRoute: UsageRoute,
  VaultRoute: VaultRoute,
  WorkflowsRoute: WorkflowsRouteWithChildren,
  ConnectCallbackRoute: ConnectCallbackRoute,
  DevContextPanelRoute: DevContextPanelRoute,
  ProjectsProjectKeyRoute: ProjectsProjectKeyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
